import { render } from "./VueCalendarView.vue?vue&type=template&id=96ac09b6&ts=true&lang=pug"
import script from "./VueCalendarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueCalendarView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/public/VueCalendarView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96ac09b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96ac09b6', __exports__)) {
    api.reload('96ac09b6', __exports__)
  }
  
  module.hot.accept("./VueCalendarView.vue?vue&type=template&id=96ac09b6&ts=true&lang=pug", () => {
    api.rerender('96ac09b6', render)
  })

}


export default __exports__